<template>
    <div class="codelab-left-side">
      <div>
        <div class="bar-item" :class="{active: selectedMenue === null}" @click="toggleSelectedMenue(null)">
            <span class="bar-icon">
                <svg-icon href="#codelab-icon-workspace" :width="20" :height="20"></svg-icon>
            </span>
            <span class="bar-label">{{$t("workspace_area")}}</span>
        </div>
        <template v-if="manageFileIs">
            <div class="bar-item" :class="{active: selectedMenue === 'program'}" @click="toggleSelectedMenue('program')">
                <span class="bar-icon">
                    <svg-icon href="#codelab-dashbord-myfile" :width="16" :height="16"></svg-icon>
                </span>
                
                <span class="bar-label">{{$t("button.my_file")}}</span>
            </div>
        </template>
        <template v-if="missionShowList.includes(langCode)">
            <div class="bar-item" :class="{active: showMissionList && selectedMenue === 'mission'}" @click="toggleSelectedMenue('mission')">
                <span class="bar-icon">
                    <svg-icon href="#codelab-dashbord-mission" :width="20" :height="20"></svg-icon>
                </span>
                <span class="bar-label">{{$t("title_mission_card")}}</span>
            </div>
        </template>
        </div>
        <!-- <div class="bar-item" :class="{active: showMissionList && selectedMenue === 'mission'}" @click="toggleSelectedMenue('mission')">
            <span class="bar-icon">
                <svg-icon href="#codelab-dashbord-mission" :width="20" :height="20"></svg-icon>
            </span>
            <span class="bar-label">{{$t("title_mission_card")}}</span>
        </div> -->
        <T-dialog class="mission-introduce" v-if="showMissionIntroduce" @dialogClose="closeDialogMask" :dialog="dialogInfo">
            <div slot="content" :class="shit$(`h:450px; bgc:#fff; radius:10px;overflow:hidden;`)">
                <div :class="shit$(`w: 450px;h:100%;float:left;overflow: hidden;line-height:450px;text-align:center;background: #EBEDE8;font-size:0;position: relative;text-align: left;`)">
                    <img :class="shit$(`w:100%;vertical-align:middle;`)" src="/static/images/mission-introduce-1.jpg" alt="">
                    <h4 :class="shit$(`w:100%;padding:0 40px;font-size:32px;font-weight:normal;position: absolute;left:0;top:48px;color:rgba(255,255,255,0.8);line-height:22px;letter-spacing:0.02em;white-space:nowrap;`)">{{$t("welcome_learn")}}</h4>
                    <p :class="shit$(`w:100%;padding:0 40px;font-size:40px;font-weight:bold;position: absolute;left:0;top:80px;color:rgba(255,255,255,0.9);line-height:36px;letter-spacing:0.02em;word-break: break-word;`)">{{$t("program_enlighten_mission")}}</p>
                </div>
                <div :class="shit$(`w:calc(100% - 450px);h:100%;float:left`)">
                    <div :class="shit$(`w:100%;overflow: hidden;color:#333;font:15px;padding:24px 48px;`)">
                        <h3 :class="shit$(`font:18px;color:#00b5e2;line-height:48px;`)">
                            {{$t("unlock_mission_title")}}
                        </h3>
                        <p :class="shit$(`line-height:2em; font-w:500;`)">
                            {{$t("unlock_mission_content")}}
                        </p>
                    </div>
                    <div :class="shit$(`font:16px; font-w:500; letter-s:1.07px; w:190px; absolute; right:77px; bottom:30px;`)">
                        
                        <el-button 
                            @click="closeDialogMask"
                            :class="shit$(`p:0px; w:100%; radius:10px; bgc:#00b5e2!; c:#fff!; border:none; hover:opacity:0.6; active:opacity:1;`)"
                        >
                            <span :class="shit$(`dis:b; h:45px; lh:45px; font:16px!; font-w:500; letter-s:1.07px; c:#fff;`)">{{$t("button.play_now")}}</span>
                        </el-button>
                        <span :class="shit$(`dis:b; c:#00b5e2; text-a:c; h:24px; lh:24px; cursor:p; mt:10px;`)" @click="toBuyKebbi">{{$t("i_want_buy_kebbi")}}</span>
                    </div> 
                </div>
            </div>
        </T-dialog>
        <div v-if="showMissionIntro || !noGetSimulatorKey" @click="openIntroBox" ref="getRoudReact" :class="shit$(`dis:f; flex-d:c; align-i:c;`)">
            <svg-icon :height="20" :width="20" :href="'#svg-tutorial-icon' + ($store.state.introStore.showBox ? '-active' : '')"></svg-icon>
            <span :class="[ shit$(`mt:6px; font:12px; letter-s:0.6px; c:#a8a8ac; px:3px; word-break:break-all; ellipsis; w:100%; text-a:c;`), $store.state.introStore.showBox && shit$(`c:#0ed3ff99;`) ]">{{this.$t( "code-lab/component/layout/left-side-bar.vue_0" ) }}</span>
        </div>
    </div>
</template>
<script>
import TDialog from "@/code-lab/view/organization/s-dialog.vue";
import { mutations as exchangeutations } from '@/code-lab/component/exchange/observable.js'

import { mapState } from "vuex";
const CONSTS = window.CONSTS;
const Cookies = window.Cookies;
const Blockly = window.Blockly
export default {
  name: "left-side-bar",
  components: {
    "T-dialog": TDialog
  },
  data() {
    return {
      showMissionIntroduce: false,
      dialogInfo: {
        isShow: true,
        width: "800px",
        closeOnModal: false,
        closeOnEscape: false,
        appendToBody: true,
        class: "playCodeToMachineDialog"
      },
      missionShowList: ['zh-TW', 'ja-JP', "en-US"]
    };
  },
  computed: {
    ...mapState([
      'langCode',
      "isSaved",
      "workSpace",
      "projectData",
      "isAllowSave",
      "selectedMenue",
      "currentVersion",
      "showMissionList"
    ]),
    manageFileIs() {
      return this.computedManageFile();
    },
    showMissionIntro () { return this.missionShowList.includes(Cookies.get("langCode")) },
    noGetSimulatorKey () { return exchangeutations.isEmpty('simulator') },
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        to.name === "task" && this.openMissionIntroduce()
        console.log(to, '$route')
      }
    } 
  },
  mounted () {
    this.$store.commit('introStore/updSimulatorDB', [{
        stack: [ { index: 5, md: 'left', target: this.$refs.getRoudReact, position: 'left', type: 'circle_', clientH: 219, clientW: 400, offsetRct: 4, data: {
            header_t1: this.$t("code-lab/component/layout/left-side-bar.vue_1"),
            header_t2: '',
            content_t1: this.$t("code-lab/component/layout/left-side-bar.vue_2"),
            btn_t1: this.$t("code-lab/component/layout/left-side-bar.vue_3"),
        } }, ]
      }])
    this.executeIntro_([ [{
          stack: [ { index: 3, md: 'left', target: this.$refs.getRoudReact, position: 'left', type: 'circle_', clientH: 219, clientW: 400, offsetRct: 4, data: {
              header_t1: this.$t("code-lab/component/layout/left-side-bar.vue_4"),
              header_t2: '',
              content_t1: this.$t("code-lab/component/layout/left-side-bar.vue_5"),
              btn_t1: this.$t("code-lab/component/layout/left-side-bar.vue_6"),
          } }, ]
      }] ])
    },
  methods: {
      executeIntro_ ([ data ]) {
        if ((localStorage.getItem('missionDB')) ) return
        this.$store.commit('introStore/updMissionDB', data)
      },
      isPublic () { return this.currentVersion === 'public' },
      computedManageFile () {
        const mapping = { public: 0, student: 1, family: 1, teacher: 1 }
        return !!mapping[this.currentVersion]
      },
      openIntroBox () {
          this.$store.commit('introStore/upShowBox', [ !this.$store.state.introStore.showBox ])
      },
    openMissionIntroduce () {
      this.showMissionIntroduce = true
    },
    toggleSelectedMenue(key) {
      if (this.selectedMenue === key) {
        if (key === "program") {
          return this.$store.commit("SELECTEDMENUERIGHT", null);
        } else if (key === "mission") {
          if (this.showMissionList) {
            this.laodEmptyProject();
            return this.$store.commit("SELECTEDMENUERIGHT", null);
          }
        }
      }
      let oldMenue = this.selectedMenue || "program";

      if (key === "mission" && oldMenue !== "mission") {
        this.openMissionIntroduce()
      }
      if (!this.isSaved && this.isAllowSave && !this.isPublic()) {
        let message = `<div class="tip-icon">
                        <svg width="150" height="150">
                            <use xlink:href="#codelab-project-unsaved"></use>
                        </svg>
                    </div>
                    ${this.$t("message.warn_before_leave_" + oldMenue)}
                `;
        this.$confirm(message, this.$t("popper_title.unsaved_" + oldMenue), {
          dangerouslyUseHTMLString: true,
          center: true,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          cancelButtonClass: "codelab-button btn",
          confirmButtonClass: "codelab-button gray",
          cancelButtonText: this.$t("button.open_" + key),
          confirmButtonText: this.$t("button.save_before_open"),
          customClass: "codelab-important-tip project-unsaved"
        }).catch(() => {
          this.$store.commit("SELECTEDMENUERIGHT", key);
          this.$nextTick(() => {
            if (key === "mission") {
              this.loadEmptyMission();
            } else if (key === "program") {
              this.laodEmptyProject();
            }
            
            this.$store.commit("UPDATE_IS_SAVED", true);
            this.$store.commit("UPDATE_IS_ALLOW_SAVED", false);
            
          });
        });
      } else {
        this.$store.commit("SELECTEDMENUERIGHT", key);
        if (key === "mission") {
          this.loadEmptyMission();
        } else if (key === "program") {
          this.laodEmptyProject();
      
      }}
    },
    laodEmptyProject() {
      this.$root.blocklyWorkSpace.clear();
      let script = Blockly.Xml.textToDom(CONSTS.EMPTY_WORK_SPACE);
      Blockly.Xml.domToWorkspace(script, this.workSpace);
      
      this.$store.commit("UPDATE_PROJECT_DATA", {
        name: this.$t("UNNAMEDPROJECT"),
        projectId: null,
        script: null,
        materials: []
      });
    },
    loadEmptyMission() {
      this.$store.commit("SET_CURRENT_MISSION", null);
      this.$store.commit("UPDATE_PROJECT_DATA", {
        name: this.$t("UNNAMEDPROJECT"),
        projectId: null,
        script: null,
        materials: []
      });
    },
    closeDialogMask() {
      this.dialogInfo.isShow = false;
    },
    toBuyKebbi() {
      
      window.open(this.util$.getNuwaWebsite());
    }
  }
};
</script>

<style lang="scss">
.codelab-left-side {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 10px;
  .bar-item {
    width: 64px;
    height: 64px;
    text-align: center;
    color: $--codelab-primary-gray-2;
    cursor: pointer;
    .bar-icon {
      display: block;
      width: 100%;
      line-height: 36px;
    }
    .bar-label {
      display: block;
      width: 100%;
      line-height: 14px;
      line-height: 16px;
      font-size: 12px;
      text-align: center;
      // white-space: nowrap;
    }
    svg {
      fill: $--codelab-primary-gray-2;
      stroke: $--codelab-primary-gray-2;
    }
    &:hover,
    &.active {
      color: $--codelab-primary-blue-1;
      svg {
        fill: $--codelab-primary-blue-1;
        stroke: $--codelab-primary-blue-1;
      }
    }
  }
}
</style>